import { select2 } from 'select2';
import 'select2/dist/css/select2.css'
import DomManipulate from "./DomManipulate";

export default class Guide2 {
  constructor(selector) {
    this.container = selector;
    this.$overlay = $(this.container);
    this.$select = $(this.container+' .js-guide-select');
    this.$blur = $(this.container+' .js-guide-background');
    this.$closeBtn = $(this.container+' .js-guide-close');
    this.userLang = document.documentElement.lang;

    this.select2Language = (this.userLang === "fr") ? {
      noResults: function () {
        return 'Aucun résultat trouvé';
      },
      searching: function () {
        return 'Recherche en cours…';
      },
    } : {
      noResults: function () {
        return 'No results found';
      },
      searching: function () {
        return 'Searching…';
      },
    }

    //Swipe vars
    this.startX;
    this.startY;
    this.dist;
    this.threshold = 100; //required min distance traveled to be considered swipe
    this.allowedTime = 500; // maximum time allowed to travel that distance
    this.elapsedTime;
    this.startTime;
  }

  init() {
    const dom = new DomManipulate();
    dom.onReady(() => {
      this.addEvents();
      this.$select.select2({ dropdownParent: $(this.container+' .js-guide-select-wrapper'), language : this.select2Language });

    })
  }

  addEvents() {
    this.$select.on('change', (e) => this.handleSelectChange(e))
    this.$select.on("select2:open", () => document.querySelector(".select2-container--open .select2-search__field").focus())
    this.$blur.on('click', () => this.hideOverlay())
    this.$closeBtn.on('click', () => this.hideOverlay());
    this.setSwipeEvent();

    var that = this;
    $('.guide-overlay'+this.container+'-hook').on('click', function() {
      that.toggleOverlay($(this).attr('data-id'));
    });
  }

  removeEvents() {
    this.$select.off();
    this.$blur.off();
    this.$closeBtn.off();
  }

  resetEvents() {
    this.removeEvents();
    this.addEvents();
  }

  handleSelectChange(pEvent) {
    this.displayItem(pEvent.target.value)
  }

  showOverlay(pItemId) {
    this.displayItem(pItemId);

    let that = this;
    console.log(this.container);
    $(this.container).addClass('show');
    $(this.container).find('.guide-content').removeClass('guide-out').addClass('guide-in'); //Open dialog

    if ( !document.querySelector('html').classList.contains('cart-opened')) {
      document.querySelector('html').classList.add('cart-opened')
    }

    setTimeout(function() {
      $(that.container).css('background-color', 'rgba(33, 37, 41, 0.8)');
    }, 0);

    $(document).on("keydown."+this.container, function(event) {
      const key = event.key;
      if (key === "Escape") {
        that.hideOverlay();
      }
    });

    this.$select.val(pItemId).trigger("change");
  }

  hideOverlay() {
    let that = this;

    $(document).off('keydown.'+this.container);

    $(this.container).find('.guide-content').removeClass('guide-in').addClass('guide-out');

    if ( document.querySelector('html').classList.contains('cart-opened')) {
      document.querySelector('html').classList.remove('cart-opened')
    }

    $(this.container).css('background-color', 'rgba(33, 37, 41, 0)');

    setTimeout(function() {
      $(that.container).removeClass('show');
    }, 500);
  }

  setSwipeEvent() {

    let element = $(this.container);
    let that = this;

    element.on('touchstart', function(e){
      let touchobj = e.changedTouches[0];

      that.dist = 0;
      that.startX = touchobj.pageX;
      that.startY = touchobj.pageY;
      that.startTime = new Date().getTime(); // record time when finger first makes contact with surface
    });

    element.on('touchend', function(e){

      let touchobj = e.changedTouches[0];

      //Get total dist traveled by finger while in contact with surface
      that.dist = touchobj.pageX - that.startX;

      //Get time elapsed
      that.elapsedTime = new Date().getTime() - that.startTime;

      //Check that elapsed time is within specified, horizontal dist traveled >= threshold, and vertical dist traveled <= 100

      let swiperightBol = (that.elapsedTime <= that.allowedTime && that.dist >= that.threshold && Math.abs(touchobj.pageY - that.startY) <= 100);

      if(swiperightBol){
        that.hideOverlay();
      }
    });
  }

  toggleOverlay(pItemId, type = null) {
    if (!this.$overlay.hasClass('show')) {
      this.showOverlay(pItemId);
    } else {
      this.hideOverlay()
    }
  }

  displayItem(pItemId) {
    let $image = this.$overlay.find('.guide-img');
    let $pdfs = this.$overlay.find('.guide-list');

    let $itemTemplate = this.$overlay.next().find('.guide-content[data-id=' + pItemId + ']');
    let newImage = $itemTemplate.find('.guide-img').attr('src');
    let newPdfs = $itemTemplate.find('.guide-list').html();

    $image.attr('src', newImage);
    $pdfs.html(newPdfs);
  }
}




